import React from 'react';
import { 
  Text,
  InlineStack
} from '@shopify/polaris';

const Breadcrumbs = ({ items = [] }) => {
  if (!items || items.length === 0) {
    return null;
  }

  return (
    <div style={{ padding: '16px 0' }}>
      <InlineStack gap="200" align="start">
        {items.map((item, index) => (
          <div key={index} style={{ display: 'flex', alignItems: 'center' }}>
            {index > 0 && (
              <Text variant="bodyMd" color="subdued" as="span">
                {' > '}
              </Text>
            )}
            {item.url ? (
              <a 
                href={item.url} 
                onClick={(e) => {
                  e.preventDefault();
                  if (item.onClick) {
                    item.onClick();
                  }
                }}
                style={{ 
                  textDecoration: 'none', 
                  color: '#0070f3',
                  cursor: 'pointer'
                }}
              >
                <Text variant="bodyMd" as="span">
                  {item.label}
                </Text>
              </a>
            ) : (
              <Text variant="bodyMd" as="span">
                {item.label}
              </Text>
            )}
          </div>
        ))}
      </InlineStack>
    </div>
  );
};

export default Breadcrumbs;